export const NEW_BLOCK_ID = '__PLACEHOLDER__' as const;
